__turbopack_context__.v({
  "className": "merriweather_f0f25f62-module__psw2jq__className",
  "variable": "merriweather_f0f25f62-module__psw2jq__variable",
});
